import { gql } from '@apollo/client';

const AI_PROCESSING_RESPONSE = gql`
  query aiProcessing($requestId: String, $type: String) {
    aiProcessing(requestId: $requestId, type: $type) {
      canSwitchTab
      processingCmd
    }
  }
`;
export default AI_PROCESSING_RESPONSE;
